export var Roles;
(function (Roles) {
    Roles["Admin"] = "Admin";
    // Features
    Roles["Workflows"] = "Feature-Workflows";
    Roles["Quotes"] = "Feature-Quotes";
    Roles["QBOStripePayments"] = "Feature-QBOStripePayments";
    Roles["PaymentPlans"] = "Feature-PaymentPlans";
})(Roles || (Roles = {}));
//# sourceMappingURL=roles.js.map